{
  "sidebar": {
    "profile": "Mon profil",
    "orders": "Mes commandes",
    "addresses": "Mes adresses",
    "returns": "Mes retours",
    "invoices": "Mes factures",
    "logout": "Déconnexion",
    "wishlist": "Mes favoris",
    "settings": "Paramètres"
  },

  "login": {
    "title": "Connexion",
    "subtitle": "Accédez à votre espace client Djayma",
    "email_label": "Adresse e-mail",
    "email_placeholder": "votre@email.com",
    "password_label": "Mot de passe",
    "password_placeholder": "Votre mot de passe",
    "forgot_password": "Mot de passe oublié ?",
    "submit": "Se connecter",
    "no_account": "Pas encore de compte ?",
    "create_account": "Créer un compte",
    "success_registered": "Compte créé avec succès. Vous pouvez maintenant vous connecter.",
    "error_email_required": "Veuillez saisir votre adresse e-mail.",
    "error_password_required": "Veuillez saisir votre mot de passe.",
    "error_invalid_credentials": "Email ou mot de passe incorrect.",
    "error_too_many_attempts": "Trop de tentatives. Réessayez dans {{seconds}}s.",
    "error_generic": "Une erreur est survenue. Veuillez réessayer.",
    "show_password": "Afficher le mot de passe",
    "hide_password": "Masquer le mot de passe",
    "reason_timeout": "Votre session a expiré. Veuillez vous reconnecter.",
    "reason_login_required": "Connectez-vous pour accéder à votre compte."
  },

  "register": {
    "title": "Créer un compte",
    "subtitle": "Rejoignez Djayma et passez vos commandes en ligne",
    "full_name_label": "Nom complet",
    "full_name_placeholder": "Prénom et nom",
    "email_label": "Adresse e-mail",
    "email_placeholder": "votre@email.com",
    "phone_label": "Téléphone",
    "phone_placeholder": "+221 77 123 45 67",
    "password_label": "Mot de passe",
    "password_placeholder": "Minimum 8 caractères",
    "password_confirm_label": "Confirmer le mot de passe",
    "password_confirm_placeholder": "Retapez votre mot de passe",
    "privacy_accept": "J'accepte la",
    "privacy_policy_link": "politique de confidentialité",
    "privacy_and_terms": "et les conditions générales d'utilisation",
    "submit": "Créer mon compte",
    "already_account": "Déjà un compte ?",
    "login_link": "Se connecter",
    "error_name_required": "Veuillez saisir votre nom complet.",
    "error_email_required": "Veuillez saisir votre adresse e-mail.",
    "error_privacy_required": "Vous devez accepter la politique de confidentialité pour créer un compte.",
    "error_phone_invalid": "Le numéro de téléphone doit être au format sénégalais (+221 XX XXX XX XX).",
    "error_password_min": "Le mot de passe doit contenir au moins 8 caractères.",
    "error_password_mismatch": "Les mots de passe ne correspondent pas.",
    "error_generic": "Une erreur est survenue. Veuillez réessayer.",
    "show_password": "Afficher le mot de passe",
    "hide_password": "Masquer le mot de passe",
    "show_confirm_password": "Afficher la confirmation du mot de passe",
    "hide_confirm_password": "Masquer la confirmation du mot de passe"
  },

  "reset_request": {
    "title": "Mot de passe oublié",
    "subtitle": "Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.",
    "email_label": "Adresse e-mail",
    "email_placeholder": "votre@email.com",
    "submit": "Envoyer le lien",
    "back_to_login": "Retour à la connexion",
    "sent_title": "Email envoyé",
    "sent_message": "Si un compte existe avec l'adresse <strong>{{email}}</strong>, vous recevrez un lien de réinitialisation dans quelques instants.",
    "check_spam": "Vérifiez aussi vos courriers indésirables (spam).",
    "error_generic": "Une erreur est survenue. Veuillez réessayer."
  },

  "reset_password": {
    "title": "Nouveau mot de passe",
    "subtitle": "Choisissez un nouveau mot de passe pour votre compte.",
    "password_label": "Nouveau mot de passe",
    "password_placeholder": "Minimum 8 caractères",
    "password_confirm_label": "Confirmer le mot de passe",
    "password_confirm_placeholder": "Retapez votre mot de passe",
    "submit": "Mettre à jour le mot de passe",
    "success_title": "Mot de passe mis à jour",
    "success_redirect": "Redirection vers votre espace client...",
    "expired_title": "Lien expiré",
    "expired_message": "Ce lien de réinitialisation est invalide ou a expiré. Veuillez en demander un nouveau.",
    "request_new_link": "Demander un nouveau lien",
    "error_password_min": "Le mot de passe doit contenir au moins 8 caractères.",
    "error_password_mismatch": "Les mots de passe ne correspondent pas.",
    "error_generic": "Une erreur est survenue. Veuillez réessayer.",
    "show_password": "Afficher le mot de passe",
    "hide_password": "Masquer le mot de passe",
    "show_confirm_password": "Afficher la confirmation du mot de passe",
    "hide_confirm_password": "Masquer la confirmation du mot de passe"
  },

  "profile": {
    "title": "Mon profil",
    "edit": "Modifier",
    "full_name_label": "Nom complet",
    "email_label": "Adresse e-mail",
    "phone_label": "Téléphone",
    "phone_placeholder": "+221 77 123 45 67",
    "phone_invalid": "Format de téléphone invalide. Exemple : +221 77 123 45 67",
    "notifications_label": "Préférences de notification",
    "notification_email": "E-mail",
    "notification_sms": "SMS",
    "notification_whatsapp": "WhatsApp",
    "language_label": "Langue préférée",
    "language_fr": "Français",
    "language_wo": "Wolof",
    "language_en": "Anglais",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "loading": "Chargement du profil...",
    "error_loading": "Impossible de charger le profil",
    "retry": "Réessayer",
    "success_message": "Profil mis à jour avec succès.",
    "error_generic": "Une erreur est survenue."
  },

  "orders": {
    "title": "Mes commandes",
    "empty_title": "Aucune commande",
    "empty_message": "Vos commandes apparaîtront ici une fois passées.",
    "column_ref": "Référence",
    "column_date": "Date",
    "column_status": "Statut",
    "column_total": "Total TTC",
    "track": "Suivre",
    "order_again": "Commander à nouveau"
  },

  "addresses": {
    "title": "Mes adresses",
    "add": "Ajouter",
    "edit_title": "Modifier l'adresse",
    "new_title": "Nouvelle adresse",
    "label_field": "Libellé (ex : Maison, Bureau)",
    "label_placeholder": "Maison",
    "phone_label": "Téléphone",
    "phone_placeholder": "+221 77 123 45 67",
    "address_label": "Adresse complète",
    "address_placeholder": "Rue 12, Villa 45",
    "quartier_label": "Quartier",
    "quartier_placeholder": "Hann Mariste",
    "commune_label": "Commune",
    "commune_placeholder": "Hann Bel-Air",
    "region_label": "Région",
    "region_select": "Sélectionner",
    "update": "Mettre à jour",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "default_badge": "Par défaut",
    "set_default": "Définir par défaut",
    "edit": "Modifier",
    "delete": "Supprimer",
    "empty_title": "Aucune adresse enregistrée",
    "empty_message": "Ajoutez une adresse de livraison pour passer commande.",
    "region_dakar": "Dakar",
    "region_kaolack": "Kaolack",
    "region_saint_louis": "Saint-Louis",
    "region_fatick": "Fatick",
    "region_thies_mbour": "Thiès-Mbour",
    "region_diourbel_touba": "Diourbel-Touba"
  },

  "returns": {
    "title": "Mes retours",
    "request_button": "Demander un retour",
    "new_request_title": "Nouvelle demande de retour",
    "close_form": "Fermer le formulaire",
    "disabled_title": "Les retours ne sont pas encore disponibles.",
    "disabled_contact": "Contactez-nous par WhatsApp au",
    "empty_title": "Vous n'avez aucune demande de retour.",
    "empty_hint": "Cliquez sur « Demander un retour » pour soumettre une demande.",
    "loading_error": "Impossible de charger vos demandes de retour.",
    "column_order": "Commande",
    "column_date": "Date",
    "column_reason": "Motif",
    "column_status": "Statut",
    "column_refund": "Remboursement",
    "form_order_label": "Commande concernée",
    "form_order_placeholder": "Sélectionner une commande",
    "form_no_orders": "Aucune commande livrée disponible pour un retour.",
    "form_reason_label": "Motif du retour",
    "form_reason_placeholder": "Décrivez le problème rencontré avec votre commande (produit endommagé, incorrect, etc.)",
    "form_reason_count": "{{count}} / {{min}} caractères minimum",
    "form_items_label": "Articles à retourner",
    "form_items_hint": "optionnel — laissez vide pour retourner toute la commande",
    "form_item_qty_available": "Qté disponible : {{qty}}",
    "form_item_qty_label": "Quantité à retourner :",
    "form_item_reason_label": "Précision pour cet article (optionnel)",
    "form_item_reason_placeholder": "Ex : Emballage ouvert, produit périmé…",
    "form_submit": "Soumettre la demande",
    "form_submitting": "Envoi en cours…",
    "form_cancel": "Annuler",
    "form_success_title": "Demande soumise avec succès",
    "form_success_message": "Votre demande de retour a bien été enregistrée.",
    "form_success_ref": "Réf. retour : {{id}}",
    "form_success_contact": "Notre équipe examinera votre demande et vous contactera dans les 48 heures.",
    "form_submit_error": "Erreur lors de l'envoi (HTTP {{status}}). Veuillez réessayer.",
    "form_photos_label": "Photos (optionnel)",
    "form_photos_hint": "Ajoutez jusqu'à 5 photos (5 Mo max chacune) pour faciliter le traitement de votre demande.",
    "form_photos_button": "Ajouter des photos",
    "form_photo_size_error": "Certaines photos dépassent 5 Mo. Veuillez choisir des fichiers plus petits.",
    "form_photo_limit_error": "Vous ne pouvez joindre que 5 photos maximum.",
    "policy_link": "Consulter notre politique de retours",
    "status_requested": "Demandé",
    "status_approved": "Approuvé",
    "status_rejected": "Refusé",
    "status_refund_pending": "Remboursement en cours",
    "status_refunded": "Remboursé",
    "status_closed": "Clôturé"
  },

  "order_status": {
    "pending": "En attente",
    "confirmed": "Confirmée",
    "processing": "En préparation",
    "shipped": "En livraison",
    "delivered": "Livrée",
    "cancelled": "Annulée"
  },

  "login_title": "Connexion",
  "login_phone": "Numéro de téléphone",
  "login_otp": "Code de vérification",
  "send_otp": "Envoyer le code",
  "verify": "Vérifier",
  "register_title": "Créer un compte",
  "profile_legacy": "Mon profil",
  "orders_legacy": "Mes commandes",
  "addresses_legacy": "Mes adresses",
  "returns_legacy": "Mes retours",
  "no_orders": "Vous n'avez pas encore de commandes",
  "order_again": "Commander à nouveau",
  "tracking_title": "Suivi de commande",
  "tracking_search": "Entrez votre référence de commande",

  "wishlist": {
    "title": "Mes favoris",
    "empty": "Vous n'avez pas encore de favoris",
    "empty_description": "Parcourez notre catalogue et ajoutez vos produits préférés",
    "remove": "Retirer",
    "add_to_cart": "Ajouter au panier",
    "added_to_cart": "Ajouté au panier",
    "removed": "Retiré des favoris",
    "browse_catalog": "Parcourir le catalogue",
    "loading": "Chargement de vos favoris...",
    "error": "Impossible de charger vos favoris",
    "retry": "Réessayer",
    "out_of_stock": "Rupture de stock",
    "share": "Partager",
    "share_created": "Lien de partage créé",
    "link_copied": "Lien copié !",
    "share_error": "Impossible de créer le lien de partage",
    "revoke_link": "Révoquer le lien",
    "share_revoked": "Lien de partage révoqué",
    "revoke_error": "Impossible de révoquer le lien",
    "copy_link": "Copier",
    "shared_loading": "Chargement de la liste de souhaits...",
    "shared_expired_title": "Lien expiré ou révoqué",
    "shared_expired_description": "Ce lien de partage n'est plus valide.",
    "shared_error": "Impossible de charger cette liste",
    "shared_default_title": "Liste de souhaits",
    "shared_by": "Liste de souhaits de {{name}}",
    "shared_empty": "Cette liste est vide pour le moment."
  },

  "settings": {
    "title": "Paramètres du compte",
    "password_title": "Modifier le mot de passe",
    "password_current": "Mot de passe actuel",
    "password_new": "Nouveau mot de passe",
    "password_new_placeholder": "Minimum 8 caractères",
    "password_confirm": "Confirmer le nouveau mot de passe",
    "password_confirm_placeholder": "Retapez le nouveau mot de passe",
    "password_submit": "Modifier le mot de passe",
    "password_success": "Mot de passe modifié avec succès.",
    "password_error": "Impossible de modifier le mot de passe.",
    "password_current_wrong": "Le mot de passe actuel est incorrect.",
    "password_min_error": "Le mot de passe doit contenir au moins 8 caractères.",
    "password_mismatch_error": "Les mots de passe ne correspondent pas.",
    "notifications_title": "Préférences de notification",
    "notifications_description": "Choisissez comment vous souhaitez être notifié",
    "channel_email": "E-mail",
    "channel_sms": "SMS",
    "channel_whatsapp": "WhatsApp",
    "prefs_updated": "Préférences mises à jour",
    "export_title": "Exporter mes données",
    "export_description": "Conformément à la Loi n° 2008-12 sur la protection des données personnelles au Sénégal, vous pouvez télécharger une copie de toutes vos données.",
    "export_button": "Télécharger mes données",
    "exporting": "Export en cours...",
    "export_success": "Données exportées avec succès",
    "export_error": "Erreur lors de l'export",
    "delete_title": "Supprimer mon compte",
    "delete_description": "Cette action est irréversible. Votre compte et toutes vos données seront supprimés sous 30 jours.",
    "delete_button": "Demander la suppression",
    "delete_confirm_title": "Confirmer la suppression",
    "delete_confirm_message": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
    "delete_reason_label": "Raison (optionnel)",
    "delete_reason_placeholder": "Dites-nous pourquoi vous souhaitez supprimer votre compte...",
    "delete_confirm_button": "Confirmer la suppression",
    "delete_cancel": "Annuler",
    "delete_success": "Votre demande de suppression a été enregistrée. Elle sera traitée sous 30 jours.",
    "delete_error": "Erreur lors de la demande de suppression"
  },

  "order_detail": {
    "title": "Détail de la commande",
    "reference": "Référence",
    "date": "Date",
    "items": "Articles",
    "quantity": "Qté",
    "unit_price": "Prix unitaire",
    "line_total": "Total",
    "subtotal_ht": "Sous-total HT",
    "tva": "TVA",
    "delivery_fee": "Frais de livraison",
    "total_ttc": "Total TTC",
    "payment": "Paiement",
    "payment_method": "Mode de paiement",
    "payment_status": "Statut du paiement",
    "delivery": "Livraison",
    "delivery_address": "Adresse de livraison",
    "delivery_status": "Statut de livraison",
    "estimated_delivery": "Livraison estimée",
    "track": "Suivre la livraison",
    "reorder": "Commander à nouveau",
    "back": "Retour aux commandes",
    "not_found": "Commande introuvable",
    "loading": "Chargement...",
    "error": "Impossible de charger la commande"
  },

  "orders.view_detail": "Voir le détail",
  "orders.reorder": "Commander à nouveau",
  "orders.reorder_success": "Articles ajoutés au panier",
  "orders.reorder_error": "Impossible de recharger la commande",
  "orders.loading": "Chargement de vos commandes...",
  "orders.empty": "Vous n'avez pas encore de commandes",
  "orders.empty_description": "Vos commandes apparaîtront ici une fois passées.",
  "orders.reference": "Référence",
  "orders.date": "Date",
  "orders.status": "Statut",
  "orders.total": "Total",
  "orders.error": "Impossible de charger vos commandes",
  "orders.error_description": "Veuillez réessayer dans quelques instants.",
  "orders.retry": "Réessayer",
  "orders.load_more": "Charger plus",
  "orders.loading_more": "Chargement...",
  "orders.total_count": "{{count}} commande",
  "orders.total_count_plural": "{{count}} commandes",

  "register.link_order_hint": "Votre commande sera automatiquement associée à votre nouveau compte.",

  "email_verification": {
    "title": "Vérifiez votre e-mail",
    "description": "Un e-mail de vérification a été envoyé à votre adresse. Cliquez sur le lien pour activer votre compte.",
    "resend": "Renvoyer l'e-mail",
    "resent_success": "E-mail de vérification renvoyé",
    "resend_no_email": "Veuillez créer votre compte à nouveau pour renvoyer l'e-mail.",
    "resend_generic_error": "Impossible de renvoyer l'e-mail. Réessayez dans quelques instants.",
    "spam_hint": "Si vous ne voyez rien après 2 minutes, vérifiez votre dossier spam ou contactez contact@cieda.sn.",
    "back_to_login": "Retour à la connexion"
  }
}
